import { css } from 'styled-components'


export const Noto_heading1_r24 = css`
  font-size: 24px;
  line-height: 38px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_heading1_r20 = css`
  font-size: 20px;
  line-height: 34px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_heading1_r17 = css`
  font-size: 17px;
  line-height: 24px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_heading1_r14 = css`
  font-size: 14px;
  line-height: 16px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_SubHeading1_r24 = css`
  font-size: 24px;
  line-height: 26px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_SubHeading1_r14 = css`
  font-size: 14px;
  line-height: 16px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_SubHeading2_r20 = css`
  font-size: 20px;
  line-height: normal;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_SubHeading2_r16 = css`
  font-size: 16px;
  line-height: normal;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_SubHeading2_b16 = css`
  font-size: 16px;
  line-height: normal;
   font-weight: 700;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_SubHeading3_r14 = css`
  font-size: 14px;
  line-height: 22px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`

export const Noto_SubHeading3_r9 = css`
  font-size: 9px;
  line-height: normal;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_Description1_r16 = css`
  font-size: 16px;
  line-height: normal;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_Description1_r14 = css`
  font-size: 14px;
  line-height: 16px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_Description2_r12 = css`
  font-size: 12px;
  line-height: normal;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_Description2_r11 = css`
  font-size: 11px;
  line-height: normal;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_Description3_r11 = css`
  font-size: 11px;
  line-height: 13px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`
export const Noto_Description3_r10 = css`
  font-size: 10px;
  line-height: 14px;
   font-weight: 400;
  font-family: "NotoSansKR", sans-serif;
`